import { Reveal, SectionHead } from "./Reveal";

const steps = [
  { n: "01", title: "Consultation", copy: "Your skin and hair are assessed." },
  { n: "02", title: "Personalised Plan", copy: "Treatment parameters are selected according to your needs." },
  { n: "03", title: "10 Laser Sessions", copy: "Sessions are scheduled according to hair-growth cycles and clinical assessment." },
  { n: "04", title: "Maintenance", copy: "Receive 1 complimentary maintenance session every year for up to 10 years, subject to package terms and clinical suitability." },
];

export const HowItWorks = () => (
  <section id="journey" data-testid="journey-section" className="py-24 md:py-36 bg-sand/50 border-y border-champagne/40">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <SectionHead index="08" eyebrow="How It Works" title="Your Treatment Journey" align="center" />
      <div className="mt-16 grid md:grid-cols-4 gap-5">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div data-testid={`journey-step-${i + 1}`} className="relative h-full rounded-3xl border border-champagne/60 bg-white p-8 overflow-hidden group">
              <span className="font-display text-6xl font-light text-champagne/70 transition-colors duration-500 group-hover:text-champagne-dark">
                {s.n}
              </span>
              <div className="mt-8 h-px w-10 bg-champagne-dark/60" aria-hidden="true" />
              <h3 className="mt-5 font-display text-xl font-medium tracking-tight text-ink">{s.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-ink/60">{s.copy}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
